import { PlayerSizesTypes } from '../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../common/styles/variables';
import {
  CONTROLS_BAR_HEIGHT,
  MORE_VIDEOS_EXTRA_LARGE_HEIGHT,
  MORE_VIDEOS_LARGE_HEIGHT,
  SEEK_BAR_HEIGHT_LARGE,
} from '../../../common/utils/common.constants';
import { flexColumn, flexRowBetween } from '../../../common/styles/flex';

interface StylesObject {
  galleryViewContainerStyle: { [key: string]: any };
  controlsWrapperStyle: { [key: string]: any };
  closeIconStyle: { [key: string]: any };
}

const galleryViewContainer = {
  ...flexColumn,
  width: '100%',
  pointerEvents: 'auto',
  backgroundColor: SITE_VARIABLES.COLORS.BLACK_80_OPACITY,
  backdropFilter: 'blur(3px)',
  webkitBackdropFilter: 'blur(3px)',
  position: 'absolute',
  height: '0px',
  transition: 'height 0.8s ease-in-out 0.5s',
  bottom: `${CONTROLS_BAR_HEIGHT + SEEK_BAR_HEIGHT_LARGE}px`,
  large: {
    height: `${MORE_VIDEOS_LARGE_HEIGHT}px`,
  },
  extraLarge: {
    height: `${MORE_VIDEOS_EXTRA_LARGE_HEIGHT}px`,
  },
  noControlsBar: {
    bottom: '4px',
  },
  endState: {
    bottom: '0px',
  },
};

const controlsWrapper = {
  ...flexRowBetween,
};

const closeIcon = {
  cursor: 'pointer',
  pointerEvents: 'auto',
  display: 'flex',
  width: '16px',
  height: '16px',
  marginRight: '8px',
  marginTop: '8px',
  endState: {
    display: 'none',
  },
};

export const getGalleryPlaylistViewStyleObject = (playerSize: PlayerSizesTypes, showControls: boolean, isEndState: boolean): StylesObject => {
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return ({
    galleryViewContainerStyle: [
      galleryViewContainer,
      largeSize && galleryViewContainer.large,
      extraLargeSize && galleryViewContainer.extraLarge,
      !showControls && galleryViewContainer.noControlsBar,
      isEndState && galleryViewContainer.endState,
    ],
    controlsWrapperStyle: {
      ...controlsWrapper,
    },
    closeIconStyle: [
      closeIcon,
      isEndState && closeIcon.endState,
    ],
  });
};
